var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommentActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.015,
    height: 23.008,
    viewBox: "0 0 25.015 23.008",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#3568ba;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-6227.083-1535.992a.335.335,0,0,1-.279-.154.356.356,0,0,1-.031-.336,14.229,14.229,0,0,0,1.03-3.972,8.735,8.735,0,0,1-2.637-6.162c0-5.17,4.807-9.376,10.716-9.376a11.735,11.735,0,0,1,6.115,1.676l-4.66,6-1.229,6.438,6.286-2.353,3.821-4.877a8.293,8.293,0,0,1,.383,2.492c0,5.17-4.807,9.376-10.716,9.376h-.018a12.134,12.134,0,0,1-3.125-.41,19.633,19.633,0,0,1-5.6,1.652A.344.344,0,0,1-6227.083-1535.992Zm18.3-14.965-2.361-2.653a9.676,9.676,0,0,1,2.363,2.652Z",
    transform: "translate(6229 1559)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.405 1.736) rotate(-7)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 9.831)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1.425,0,0,4.417,4.417,2.992Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.425 1.856)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 9.831,
    height: 4.274,
    transform: "translate(0 6.951) rotate(-45)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.401 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.633,2.208,1.638.214a.689.689,0,0,0-1,0L0,.855,2.992,3.847l.641-.641A.689.689,0,0,0,3.633,2.208Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentActive);
export default __webpack_public_path__ + "static/media/comment_active.49590731d33833b7f8031f0d3a58776a.svg";
export { ForwardRef as ReactComponent };